import axios from 'axios';

export const API_BASE_URL = "http://api.streamein.8li.io";

export const api = axios.create({
  baseURL: `${API_BASE_URL}/v1`,
});